<template>
  <div>
    <Create @save="getByStoreId" :createDialog="createDialog" @close="createDialog = false"></Create>
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ $t('pageHeader.prepaid') }}</h1>
        </v-toolbar-title>
        <v-btn v-if="checkRightStatus(68)" color="teal" dark="dark" small="small" absolute="absolute" bottom="bottom"
          right="right" fab="fab" @click="add">
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-title>
        <v-flex xs12="xs12" md4="md4">
          <v-text-field v-model="search" append-icon="search" label="Search" single-line="single-line"
            hide-details="hide-details" clearable="clearable"></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table :headers="headers" item-key="id" :items="prepaid" :search="search" :loading="loading"
        :pagination.sync="pagination">
        <template slot="items" slot-scope="props">
          <tr class="pointer">
            <td class="text-xs-left">{{ props.item.creditID }}</td>
            <td class="text-xs-left">
              <div>{{ $moment(props.item.createDateTime).format('MM/DD/YYYY h:m a') }}</div>
              <div v-if="props.item.chargeId"><span>Charged ID</span>
                <v-tooltip class="ml-1 pointer" bottom><template slot="activator"><a
                      @click="openStripe(props.item.chargeId)">
                      {{ props.item.chargeId }}
                    </a></template><span>View on stripe</span></v-tooltip>
              </div>
            </td>
            <td class="text-xs-left">{{ props.item.userName }}</td>
            <td class="text-xs-left">{{ props.item.refID }}</td>
            <td class="text-xs-left">{{ props.item.amount | currency }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
          results.</v-alert>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import walletService from '../service.js'
import Create from './Create'
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      createDialog: false,
      expand: false,
      headers: [
        {
          text: this.$t('labels.id'),
          value: 'creditID',
          sortable: true,
        },
        {
          text: this.$t('labels.createdAt'),
          value: 'createDateTime',
          sortable: true,
        },
        {
          text: this.$t('labels.userName'),
          value: 'userName',
          sortable: true,
        },
        {
          text: this.$t('labels.refNumber'),
          value: 'refID',
          sortable: true,
        },
        {
          text: this.$t('labels.amount'),
          value: 'amount',
          sortable: true,
        },
      ],
      search: null,
      prepaid: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: 'creditID',
        descending: true,
      },
    }
  },
  components: {
    Create
  },
  computed: {
    ...mapGetters('location', ['location']),
    ...mapGetters('global', ['checkRightStatus']),
  },
  created() {
    this.getByStoreId()
  },
  watch: {
    location() {
      this.getByStoreId()
    }
  },
  methods: {
    ...mapActions('global', ['setPageTitle']),
    openStripe(id) {
      window.open(
        // https://dashboard.stripe.com/test/payments/ch_2NDoHEhVM1YjUJRN0rc9nnVh
        `https://dashboard.stripe.com/test/payments/${id}`,
        '_blank',
      );
    },
    add() {
      this.createDialog = !this.createDialog
    },
    getByStoreId() {
      this.loading = true
      return walletService
        .getByStoreId(this.location.storeID)
        .then((response) => {
          console.log('response', response)
          this.prepaid = response.data
          this.loading = false
        })
    },
  }
}
</script>

<style scoped></style>
